/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import Loading from '@/components/Loading/index.vue';
import PageHeader from '@/components/PageHeader/index.vue';
import BuildItemCreateForm from '@/components/BuildItemCreateForm';
import {LoadingState, LoadingStateInterface} from '@/components/Loading/types';
import {UgcItemInterface} from '@/store/modules/ugc-item/types';
import ProgressStatus from '@/components/ProgressStatus/index.vue';
const namespace: string = 'ugcBuildModule';

/**
 * Build add view (component).
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-build-add',
    components: {
        'c-loading': Loading,
        'c-page-header': PageHeader,
        'c-build-item-create-form': BuildItemCreateForm,
        'c-progress-status': ProgressStatus,
    },
})
export default class BuildAdd extends Vue {
    @Getter('item', {namespace}) public item!: UgcItemInterface;
    @Prop(String) public itemId!: string;

    public state: LoadingStateInterface = new LoadingState(false, false);
}
